import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, shareReplay, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SessionStorageService } from '../services/session-storage.service';
import { references } from '../services/references';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SignalWebsocketsService } from '../services/SignalWebsockets.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const storage = inject(SessionStorageService);
  const snackBar = inject(MatSnackBar);
  const ws = inject(SignalWebsocketsService);

  const token = storage.load(references._STORAGE_TOKEN);

  // Valida request Não Mapeado
  if (
    req.headers.has('Skip-Interceptor') &&
    req.headers.get('Skip-Interceptor') === 'true'
  ) {
    const newRequest = req.clone({
      headers: req.headers.delete('Skip-Interceptor'),
    });
    return next(newRequest);
  }

  // Valida existencia do token
  if (!token) {
    console.log('Token ausente');
    authService.logOut();
    ws.disconnect();
    router.navigateByUrl('/login');
    return next(req);
  }

  // Valida expiração do token
  const isTokenExpired = (): boolean => {
    const jwtPayload = storage.getInfoFromToken();
    const expirationDate = jwtPayload.exp * 1000;
    const currentTime = Date.now();

    return currentTime > expirationDate;
  };

  if (isTokenExpired()) {
    authService.logOut();
    router.navigateByUrl('/login');
    return throwError(() => new Error('Token expired'));
  }

  // Validar ROLE Token
  try {
    const decodedToken = storage.getInfoFromToken();

    const allowedRoles = references._USER_ROLES;
    const userRoles = decodedToken.role;

    if (
      (typeof userRoles === 'string' && !allowedRoles.includes(userRoles)) ||
      (Array.isArray(userRoles) &&
        !userRoles.some((role) => allowedRoles.includes(role)))
    ) {
      authService.logOut();
      router.navigateByUrl('/login');
      snackBar.open('Usuário não autorizado.', 'fechar', {
        horizontalPosition: 'right',
        verticalPosition: 'top',
      });

      return next(req);
    }
  } catch (error) {
    console.error('Error decoding token', error);
    authService.logOut();
    router.navigateByUrl('/login');
    return next(req);
  }

  // Injeta token
  const authReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`),
  });

  return next(authReq).pipe(shareReplay());
};
